import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { AgencyQuery as AgencyQueryType, AgencyQueryVariables } from "./__generated__/AgencyQuery";

const AgencyQuery = loader("./AgencyQuery.gql");

type AgencyQueryProviderType = (props: {
  children: (data: AgencyQueryType) => ReactNode;
  variables: AgencyQueryVariables;
}) => ReactElement;

export const AgencyQueryProvider: AgencyQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<AgencyQueryType, AgencyQueryVariables>(AgencyQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
